import network_graph from 'modules/network_graph'

const trade_chart = 'trade_chart'
const industrial_economic_impact_chart = 'industrial_economic_impact_chart'

// chart表示領域の存在フラグ
let trade_chart_flg = false
let industrial_economic_impact_chart_flg = false

const graph_container_id = 'ajax_industry_trade_chart'
let trade_chart_id = document.getElementById(graph_container_id);

// 領域の存在確認
if (trade_chart_id !== null){
  trade_chart_flg = true
  network_graph.init(graph_container_id, trade_chart);
}

const graph_container_id2 = 'ajax_industry_industrial_economic_impact_chart'
let industrial_economic_impact_chart_id = document.getElementById(graph_container_id2);

// 領域の存在確認
if (industrial_economic_impact_chart_id !== null){
  industrial_economic_impact_chart_flg = true
  network_graph.init(graph_container_id2, industrial_economic_impact_chart);
}

$('#year').on('change', function(event){
  selectUpdateIndustryCategoryCode(event);
  ajax_request()
});

$('#code').on('change', function(){
  ajax_request()
});

function ajax_request() {
  $.ajax({
    url: gon.search_path,
    data: {
      year: $('#year').val(),
      code: $('#code').val()
    },
    dataType: 'json',
    success: function(data) {
      $('#ajax_industry_trade_chart_subtitle').html(data[0]["subtitle"]);
      $('#ajax_industry_industrial_economic_impact_chart_subtitle').html(data[1]["subtitle"]);
      // データが存在しない場合凡例を非表示に
      if (data[1]["subtitle"] != null) {
        $('ul#legend-items').show();
      } else {
        $('ul#legend-items').hide();
      }
      if (trade_chart_flg) {
        network_graph.draw(graph_container_id, data[0]["nodes"], data[0]["edges"], data[0]["options"], trade_chart);
      }
      if (industrial_economic_impact_chart_flg) {
        network_graph.draw(graph_container_id2, data[1]["nodes"], data[1]["edges"], data[1]["options"], industrial_economic_impact_chart);
      }
    },
  })
}

// 産業を指定するのselectの中身を年度に該当する産業のみに変更
function selectUpdateIndustryCategoryCode(event){
  let select = document.getElementById('code');
  // option要素を削除
  while (0 < select.childNodes.length) {
    select.removeChild(select.childNodes[0]);
  }
  let select_year = event.currentTarget.value;
  let select_industry_category_codes = JSON.parse($('.data-getter').attr('data-getter'));
  let industry_category_code_list = []
  select_industry_category_codes.forEach(function( value ) {
    let year = value[0]
    let industry_category_code_name = value[1]
    let industry_category_code = value[2]
    if (!select_year) {
      if (!industry_category_code_list.includes(industry_category_code)) {
        industry_category_code_list.push(industry_category_code);
        // option要素を生成
        let option = document.createElement('option');
        //option要素にvalueと表示名を設定
        option.value = industry_category_code;
        option.textContent = industry_category_code_name;
        select.appendChild(option)
      }
    } else if (year == select_year) {
      // option要素を生成
      let option = document.createElement('option');
      //option要素にvalueと表示名を設定
      option.value = industry_category_code;
      option.textContent = industry_category_code_name;
      select.appendChild(option)
    }
  });
  if (select.childNodes.length === 0) {
    // option要素を生成
    let item_option = document.createElement('option');
    //option要素にvalueと表示名を設定
    item_option.value = "0";
    item_option.textContent = "";
    select.appendChild(item_option)
  }
}
